/**
 * UA Management — mock Staff UA Pool seed (Phase 5).
 * MOCK ONLY. Stopping point 2026-08-20. Resume: page STATUS header.
 */
import type { StaffUaPoolMember } from "./types";

/** Initial paid-staff mock pool (all active) */
export const MOCK_STAFF_UA_POOL: StaffUaPoolMember[] = [
  {
    id: "mock-s01",
    displayName: "TJ Stewart",
    active: true,
    addedAt: "2026-01-01T12:00:00.00Z",
    deactivatedAt: null,
  },
  {
    id: "mock-s02",
    displayName: "Mike Grenier",
    active: true,
    addedAt: "2026-01-01T12:00:00.00Z",
    deactivatedAt: null,
  },
  {
    id: "mock-s03",
    displayName: "Kenny Yerton",
    active: true,
    addedAt: "2026-01-01T12:00:00.00Z",
    deactivatedAt: null,
  },
  {
    id: "mock-s04",
    displayName: "Frankie Garcia-Leon",
    active: true,
    addedAt: "2026-01-01T12:00:00.00Z",
    deactivatedAt: null,
  },
  {
    id: "mock-s05",
    displayName: "Elisha Baker",
    active: true,
    addedAt: "2026-01-01T12:00:00.00Z",
    deactivatedAt: null,
  },
  {
    id: "mock-s06",
    displayName: "Brent McGalliard",
    active: true,
    addedAt: "2026-01-01T12:00:00.00Z",
    deactivatedAt: null,
  },
  {
    id: "mock-s07",
    displayName: "Joe Clift",
    active: true,
    addedAt: "2026-01-01T12:00:00.00Z",
    deactivatedAt: null,
  },
];
